import hasPartner from './hasPartner';

export default (owner, familySituation) => !('partner' === owner && !hasPartner(familySituation));
